import type { Route } from '@application/types';
import type { UseRouterReturn } from '@application/utils';

export const proLinks = (
  translate: UseRouterReturn['translate'],
  navigateToRoute: UseRouterReturn['navigateToRoute'],
  routeLocationDescriptor: UseRouterReturn['routeLocationDescriptor'],
  homeRoute: Route,
) => [
  {
    label: translate('header.home'),
    onClick: () => navigateToRoute(homeRoute),
    link: routeLocationDescriptor(homeRoute),
  },
  {
    label: translate('header.vets'),
    onClick: () => navigateToRoute('vetList'),
    link: routeLocationDescriptor('vetList'),
    links: [
      {
        label: translate('header.vets'),
        onClick: () => navigateToRoute('vetList'),
        link: routeLocationDescriptor('vetList'),
      },
      {
        label: translate('header.vetRegister'),
        onClick: () => navigateToRoute('joinVet'),
        link: routeLocationDescriptor('joinVet'),
      },
    ],
  },
  {
    label: translate('header.groomers'),
    onClick: () => navigateToRoute('groomerList'),
    link: routeLocationDescriptor('groomerList'),
    links: [
      {
        label: translate('header.groomers'),
        onClick: () => navigateToRoute('groomerList'),
        link: routeLocationDescriptor('groomerList'),
      },
      {
        label: translate('header.groomerRegsiter'),
        onClick: () => navigateToRoute('joinGroomer'),
        link: routeLocationDescriptor('joinGroomer'),
      },
    ],
  },
  {
    label: translate('header.educators'),
    onClick: () => navigateToRoute('educatorList'),
    link: routeLocationDescriptor('educatorList'),
    links: [
      {
        label: translate('header.educators'),
        onClick: () => navigateToRoute('educatorList'),
        link: routeLocationDescriptor('educatorList'),
      },
      {
        label: translate('header.educatorRegister'),
        onClick: () => navigateToRoute('joinEducator'),
        link: routeLocationDescriptor('joinEducator'),
      },
    ],
  },
];
